"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var EmptyState = function EmptyState(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M234 223.5h19c-.721-5.428 1.082-9.968 5.408-13.622 4.967-4.074 10.865-3.16 14.033-1.755 3.167 1.406 5.52 3.338 7.15 6.982.691 1.535 1.161 2.833 1.409 3.895",
    stroke: "#C2E8FF",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M273 226.5c1.056-3.654 3.223-6.043 6.501-7.167 4.917-1.686 9.579.559 11.441 2.819 1.863 2.259 2.453 4.074 2.805 5.968.234 1.263.318 2.723.253 4.38 4.142-.169 6.919.665 8.332 2.5 1.708 2.193 1.883 4.817 1.261 6.75-.622 1.932-2.698 4.75-6.593 4.75h-79M208 233.5h65M190 233.5h8M344 178.5h19c-.721-5.428 1.082-9.968 5.408-13.622 4.967-4.074 10.865-3.16 14.033-1.755 3.167 1.406 5.52 3.338 7.15 6.982.691 1.535 1.161 2.833 1.409 3.895",
    stroke: "#C2E8FF",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M383 181.5c1.056-3.654 3.223-6.043 6.501-7.167 4.917-1.686 9.579.559 11.441 2.819 1.863 2.259 2.453 4.074 2.805 5.968.234 1.263.318 2.723.253 4.38 4.142-.169 6.919.665 8.332 2.5 1.708 2.193 1.883 4.817 1.261 6.75-.622 1.932-2.698 4.75-6.593 4.75h-79M318 188.5h65M300 188.5h8M79 311.5h450",
    stroke: "#C2E8FF",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m111 311 75.5-62 58 45.123M227 279.943 244.5 265l56.5 46",
    stroke: "#C2E8FF",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m121.894 281.969 3.499 16.461-11.94 9.215 6.494-25.713a1 1 0 0 1 1.947.037ZM278.963 276.44 285 298l-11.23-9.893 3.267-11.667a1 1 0 0 1 1.926 0Z",
    fill: "#C2E8FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m126.966 286.359 2.461 9.228-3.602 2.148H122l3.034-11.376a1 1 0 0 1 1.932 0Z",
    fill: "#C2E8FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m499.5 309-87-87-66 68",
    stroke: "#C2E8FF",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.931 281.59 497 305l-11.23-11.894 3.23-11.535a1 1 0 0 1 1.931.019Z",
    fill: "#C2E8FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m364.5 268-23-21-53 53",
    stroke: "#C2E8FF",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m425.421 264.455 14.338 49.489a1.998 1.998 0 0 1-1.921 2.556h-28.676a2 2 0 0 1-1.921-2.556l14.338-49.489a2 2 0 0 1 3.842 0Z",
    fill: "#C2E8FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "m423.5 262.824 17 53.676h-34l17-53.676Z",
    stroke: "#8CD3F8",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M423.5 266.195V325v-58.805Z",
    stroke: "#8CD3F8",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M431.5 291.824c-5.333 6.461-8 9.795-8 10 0-.205 2.667-3.539 8-10Z",
    stroke: "#8CD3F8",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m389.648 229.5 25.231 84.427a2 2 0 0 1-1.916 2.573h-46.63a2 2 0 0 1-1.916-2.573l25.231-84.427Z",
    fill: "#C2E8FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "m389.5 229.5 26 87h-52l26-87Z",
    stroke: "#8CD3F8",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M389.5 232.086V325v-92.914Z",
    stroke: "#8CD3F8",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M378.648 271.5c7.333 7.079 11 10.745 11 11 0-.255-3.667-3.921-11-11ZM390.648 297.5c9.333-10.921 14-16.255 14-16 0-.255-4.667 5.079-14 16Z",
    stroke: "#8CD3F8",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m164.421 264.455 14.338 49.489a1.998 1.998 0 0 1-1.921 2.556h-28.676a2 2 0 0 1-1.921-2.556l14.338-49.489a2 2 0 0 1 3.842 0Z",
    fill: "#C2E8FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "m162.5 262.824 17 53.676h-34l17-53.676Z",
    stroke: "#8CD3F8",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M162.5 266.824V325v-58.176Z",
    stroke: "#8CD3F8",
    strokeWidth: "3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M172.5 294.824c-6.667 7.128-10 10.795-10 11 0-.205 3.333-3.872 10-11Z",
    stroke: "#8CD3F8",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M119 323.5h356M482 323.5h10",
    stroke: "#8CD3F8",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M212 194c36.451 0 66-29.549 66-66 0-36.45-29.549-66-66-66s-66 29.55-66 66c0 36.451 29.549 66 66 66Z",
    fill: "#C2E8FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M212.5 194c21.263 0 38.5-29.549 38.5-66 0-36.45-17.237-66-38.5-66S174 91.55 174 128c0 36.451 17.237 66 38.5 66ZM227.5 215.5h-32v22h32v-22Z",
    fill: "#C2E8FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.277 109.779c4.451-11.71 11.529-21.265 21.235-28.663 8.608-6.319 14.195-10.023 26.579-12.24 3.758-.673 8.067-5.913 12.927-5.99 5.975-.094 12.707 5.199 19.336 6.949 5.747 1.518 11.53 3.924 16.984 7.559 16.862 11.237 20.619 20.1 26.624 32.385 4.003 8.189 3.681 5.531-.967-7.973l-7.839-13.428-15.806-14.539-20.023-8.697-21.108-2.256-17.128 3.512-18.422 9.415-16.227 16.258-6.165 12.961v4.747Z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.495 96.05s6.843-17 17.285-24.12c5.73-3.796 11.42-5.415 17.069-4.858 4.434.427 9.099 2.487 13.993 6.181 7.342 5.541 13.293 16.544 16.59 24.575 2.198 5.353.836.728-4.086-13.874-5.415-7.05-8.305-10.714-8.67-10.993-.364-.279-3.624-3.136-9.78-8.572-4.117-1.5-7.258-2.27-9.424-2.311-2.165-.04-5.418.609-9.758 1.949l-7.897 5.755-8.356 8.522c-4.088 6.8-6.261 10.337-6.521 10.613-.389.413-.445 7.132-.445 7.132Z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M212 194c36.451 0 66-29.549 66-66 0-36.45-29.549-66-66-66s-66 29.55-66 66c0 36.451 29.549 66 66 66Z",
    stroke: "#8CD3F8",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M212.5 194c21.263 0 38.5-29.549 38.5-66 0-36.45-17.237-66-38.5-66S174 91.55 174 128c0 36.451 17.237 66 38.5 66ZM227.5 215.5h-31v22h31v-22ZM228 215l26-36M218 215l7-22M206 215l-7-22M196 215l-26-36",
    stroke: "#8CD3F8",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M460 180c18.225 0 33-14.775 33-33s-14.775-33-33-33-33 14.775-33 33 14.775 33 33 33Z",
    stroke: "#C2E8FF",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M460.25 180c10.631 0 19.25-14.775 19.25-33s-8.619-33-19.25-33S441 128.775 441 147s8.619 33 19.25 33ZM469 190.5h-18v11h18v-11ZM468 190.5l13-18M463 190.5l3.5-11M457 190.5l-3.5-11M452 190.5l-13.5-18",
    stroke: "#C2E8FF",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M106.51 199.676s9.79 1.7 7.257 11.612M127.765 208.851s-7.366-6.668-13.618 1.431M81.209 236.597s8.503-5.139 13.094 4.003M104.017 230.486s-9.934-.199-9.34 10.014",
    stroke: "#C2E8FF",
    strokeWidth: "3",
    strokeLinecap: "round"
  }));
};
EmptyState.defaultProps = {
  viewBox: "0 0 600 400",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var styles = {
  "empty-page": "EmptyPage__empty-page__9lusr",
  "emptyPage": "EmptyPage__empty-page__9lusr"
}; 
require('./EmptyPage.css');
var EmptyPage = function EmptyPage(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 400 : _ref$size,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'assets-detail-empty-page' : _ref$testId;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.emptyPage,
    "data-test-id": testId
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: size
  }, /*#__PURE__*/_react.default.createElement(EmptyState, null)));
};
var _default = exports.default = EmptyPage;
//# sourceMappingURL=EmptyPage.js.map